(function() {
  define('bazemont/content/pageNav',['jquery', 'bootstrap', 'angular', 'angularSanitize'], function($) {
    'use strict';
    return angular.module('bazemontContentPageNav', ['ngSanitize']).component('bazemontContentPageNav', {
      templateUrl: '/assets/javascripts/bazemont/content/pageNav.html',
      bindings: {
        page: '<',
        navRight: '<'
      },
      controller: [
        '$timeout', function($timeout) {
          var vm;
          vm = this;
          vm.$onInit = function() {
            return $timeout(function() {
              $('#nav-right').affix({
                offset: {
                  top: $('#nav-right').offset().top - 91,
                  bottom: $('footer').outerHeight(true) + 95
                }
              });
              $('body').scrollspy({
                target: '.scrollspy'
              });
              return $('a.scroll').on('click', function(evt) {
                var target;
                evt.preventDefault();
                target = $(this).attr('href');
                return $('html, body').stop().animate({
                  scrollTop: $(target).offset().top - 68
                }, 500);
              });
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=pageNav.js.map
;
